import {
  leadMagnetPageFetch,
  leadMagnetPagePlayVideo,
  leadMagnetPageClearVideo,
  toggleNewsletterAction,
  claimLeadMagnet,
  disableCtaAction,
  enableCtaAction,
  types,
  hideDialogAction,
  dialogSubmittedAction
} from './'
import notifications, {
  toastError,
  toastServerError,
  toastSuccess
} from '../../../global/notifications'

export const leadMagnetPageDispatchers = (dispatch, props) => ({
  loadLeadMagnetPage() {
    dispatch(leadMagnetPageFetch(props.params.slug)())
  },
  loadLeadMagnetPageVideo(payload) {
    dispatch(leadMagnetPagePlayVideo(payload))
  },
  clearLeadMagnetPageVideo() {
    dispatch(leadMagnetPageClearVideo())
  }
})

export const onLeadMagnetFunnelFormDispatch = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps
  return {
    ...stateProps,
    ...ownProps,
    onSubmit: (data) => {
      dispatch(disableCtaAction())
      dispatch(claimLeadMagnet({ email: data.email, tag: ownProps.tag }))
        .then(([_, res]) => {
          if (res.type === types.CLAIM_LEAD_MAGNET_REQUEST_SUCCESS) {
            toastSuccess(notifications.funnelConversion)
            dispatch(hideDialogAction())
            dispatch(dialogSubmittedAction())
          }
          if (res.type === types.CLAIM_LEAD_MAGNET_REQUEST_FAILURE) {
            toastError(notifications.funnelConversion)
            if (res?.payload?.email[0])
              toastServerError(res?.payload?.email[0])
          }
        })
        .catch((payload) => {
          const error = payload.errors
          toastServerError(error)
        })
        .finally(() => dispatch(enableCtaAction()))
    },
    toggleNewsletter: () => dispatch(toggleNewsletterAction())
  }
}
